import { consume } from '@lit/context';
import { t } from 'i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

import {
  global,
  GlobalComponentType,
  visualDesigner,
  VisualDesignerContextType,
} from '@/context';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles, buttonStyles, typographyStyles } from '@/styles';

import '../login/fg-login-cta';
import '../translation/fg-translation-wrapper';

@customElement('fg-login-cta')
export class FgLoginCta extends LitElement {
  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  @consume({ context: visualDesigner.context, subscribe: true })
  visualDesignerContext!: VisualDesignerContextType;

  handleLoginClick() {
    this.dispatchEvent(new CustomEvent('customer-login', { composed: true }));
  }

  handleContactClick() {
    this.dispatchEvent(
      new CustomEvent('customer-service-contact', {
        composed: true,
      }),
    );
  }

  render() {
    if (this.globalContext.loggedIn) {
      return nothing;
    }

    return html`
      <section>
        <h2 class="h4">${t('labels.loginToOrder')}</h2>
        <button class="button button-cta" @click=${this.handleLoginClick}>
          ${t('actions.login')}
        </button>
        <p>
          <fg-translation-wrapper
            .translationKey=${'content.login.contactNotice'}
          >
            <span
              role="button"
              tabindex="0"
              slot="inner-html"
              class="button-link"
              @click=${this.handleContactClick}
            >
              <u>${t('content.login.contactNoticeLink')}</u>
            </span>
          </fg-translation-wrapper>
        </p>
      </section>
    `;
  }
  static styles = [
    baseStyles,
    buttonStyles,
    typographyStyles,
    css`
      section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      p {
        margin-top: 0.5rem;
        text-align: center;
      }

      .button-cta {
        width: 100%;
        margin-top: 1rem;
      }

      .button-link {
        text-decoration: none;
        cursor: pointer;
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        section {
          padding: 1.5rem;
          margin-top: 56px;
          border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
          border-radius: var(
            --fg-borderradius--lg,
            var(--fg-fallback-borderradius--lg)
          );
        }
        .button-cta {
          margin-top: 1.5rem;
        }
      }
    `,
  ];
}
